<template>
	<div class="customFixed-vue alertPOP darkFadeBG heightAuto priceAlert">
	    <div class="custom-modal showTabs secondary-color openHeader">
	    	<div class="mainContent" v-if="tempOrderId == ''">
	    		<div class="topSettingHead position-relative border-bottom p-3">
	    			<p class="f-14 mb-0" v-if="editalert && editalert.Symbol">{{$t('edit_price_alert') }} <span class="green font-weight-bold ml-2">{{currency_pair}}</span></p>
	    			<p class="f-14 mb-0" v-else>{{$t('create_price_alert') }}  <span class="green font-weight-bold ml-2">{{currency_pair}}</span></p>
	    			<span class="closePOP" @click.prevent="$parent.editalert = {}" v-if="editalert && editalert.Symbol"><feather size="13px" type="x"></feather></span>
					<span class="closePOP" @click.prevent="$parent.alertTab = false" v-else><feather size="13px" type="x"></feather></span>
	    		</div>
	    		<div class="mainTab-one px-4">
		    	<form class="updateWrap" @submit.prevent="addAlert()">
		    		<p class="ltP f-14 mb-4">{{$t('condition') }} </p>
		    		<div class="d-flex justify-content-between">
		    	 		<div class="w-100">
							<div class="twoColmn d-flex align-items-center p-0">
								<div class="form-fields p-0 d-flex align-items-center mb-3">
									<label class="customRadiobox mb-0">
	                                    <span class="green font-weight-bold">{{$t('bid') }}  <span class="bid f-14 ml-1">{{instruments[currency_pair].B}}</span></span>
	                                    <input type="radio" v-model="tradeType" :value="'B'"/>
	                                    <span class="checkmark"></span>
	                                </label>
	                            </div>
								<div class="form-fields p-0 d-flex align-items-center mb-3">
	                                <label class="customRadiobox mb-0">
	                                    <span class="red font-weight-bold">{{$t('Ask') }}  <span class="bid f-14 ml-1">{{instruments[currency_pair].A}}</span></span>
	                                    <input type="radio" v-model="tradeType" :value="'A'"/>
	                                    <span class="checkmark"></span>
	                                </label>
	                            </div>
							</div>
							<div class="twoColmn d-flex align-items-center p-0">
								<div class="form-fields p-0 d-flex align-items-center mb-3">
									<label class="customRadiobox mb-0">
										{{$t('crossing_above') }} 
	                                    <input type="radio" v-model="condition" :value="1"/>
	                                    <span class="checkmark"></span>
	                                </label>
	                            </div>
								<div class="form-fields p-0 d-flex align-items-center mb-3">
	                                <label class="customRadiobox mb-0">
										{{$t('crossing_below') }}
	                                    <input type="radio" v-model="condition" :value="0"/>
	                                    <span class="checkmark"></span>
	                                </label>
	                            </div>
	                        </div><!--  current price {{instruments[currency_pair][tradeType]}} -->
							<div class="twoColmn d-flex p-0 align-items-center p-0">
								<div class="form-fields px-0" :class="[{'validation-error':submitted && errors.has('Price')}]">
									<div class="lightBC d-flex align-items-center darkBG">
										<input type="number" :step="getStep(price)" min="0" :placeholder="instruments[currency_pair][tradeType]" v-model="price" name="Price" v-validate="{'required':true, greaterThen : instruments[currency_pair][tradeType]}" ref="priceInput" v-if="condition"/>
										<input type="number" :step="getStep(price)" min="0" :placeholder="instruments[currency_pair][tradeType]" v-model="price" name="Price" v-validate="{'required':true, lessThen : instruments[currency_pair][tradeType]}" ref="priceInput" v-else/>
										<span class="addHighLow">
	                                        <a href="javascript:void(0)" @click.stop="changeTick('priceInput',1,'price')"><feather type="plus"></feather> </a>
	                                        <a href="javascript:void(0)" @click.stop="changeTick('priceInput',0,'price')"><feather type="minus"></feather> </a>
	                                    </span>
	                                </div>
									<span class="text-danger-error" v-if="submitted && errors.has('Price')">
	                                    <span class="text-danger" v-if="errors.first('Price').includes('decimal points')">
											{{$t('price_required') }} </span>
	                        			<span class="text-danger" v-else-if="errors.first('Price').includes('is not valid')">
											{{$t('price_must_be') }}  {{(condition)? 'Greater':'Less'}} {{$t('then') }} {{ instruments[currency_pair][tradeType]}}</span>
	                        			<span class="text-danger" v-else>{{ errors.first('Price') }}</span>
	                        		</span>
								</div>
							</div>
							<div class="twoColmn d-flex p-0 align-items-center p-0">
                                <div class="form-fields px-0" :class="[{'validation-error':submitted && errors.has('Comment')}]">
                                    <div class="d-flex align-items-center justify-content-between maximumChar">
                                        <label class="commentBox">{{$t('add_comment') }} </label>
                                        <p class="charterOnly m-0">{{$t('maximum_100_characters') }}  <span class="green ml-2">{{comment.length}} / <span class="ltr-char">100</span></span> </p>
                                    </div>
                                    <textarea class="textarea darkBG" maxlength="100" v-model="comment" name="Comment" v-validate="'max:100'"></textarea>
                                    <span class="text-danger mt-0" v-if="submitted && errors.has('Comment')">{{ errors.first('Comment') }}</span>
                                </div>
                            </div>
				    	</div>
					</div>
					<div class="fullWidh w-100 text-center my-4">
						<button class="btn appButton linkBG mx-auto justify-content-center large" v-if="editalert && editalert.Symbol">{{$t('edit_alert') }} </button>
						<button class="btn appButton linkBG mx-auto justify-content-center large" v-else>{{$t('create_alert') }} </button>
					</div>
				</form>
			    </div>
	    	</div>
	    	<div class="mainContent text-center" v-else-if="tempOrderId != '' && !wsOrder.hasOwnProperty(tempOrderId)">
		    	<div class="topSettingHead position-relative border-bottom p-3">
	    			<p class="f-14 mb-0" v-if="editalert && editalert.Symbol">{{$t('edit_price_alert') }}  <span class="green font-weight-bold ml-2">{{currency_pair}}</span></p>
	    			<p class="f-14 mb-0" v-else>{{$t('create_price_alert') }} <span class="green font-weight-bold ml-2">{{currency_pair}}</span></p>
					<span class="closePOP" @click.prevent="$parent.editalert = {}" v-if="editalert && editalert.Symbol"><feather size="13px" type="x"></feather></span>
					<span class="closePOP" @click.prevent="$parent.alertTab = false" v-else><feather size="13px" type="x"></feather></span>
	    		</div>
                <div class="ppSuccess-icon text-center mt-3 mb-2">
                    <feather size="28px" type="clock"></feather>
                </div>
                <div class="loadShow">
                    <app-loader />
                </div>
                <a href="#" class="btn appButton linkBG justify-content-center mt-4 mb-4 mx-auto" @click.prevent="$parent.editalert = {}" v-if="editalert">{{$t('close') }}</a>
                <a href="#" class="btn appButton linkBG justify-content-center mt-4 mb-4 mx-auto" @click.prevent="$parent.alertTab = false" v-else>{{$t('close') }}</a>
		    </div>
		    <div class="mainContent text-center pb-4" v-else-if="wsOrder.hasOwnProperty(tempOrderId)">
		    	<div class="topSettingHead position-relative border-bottom p-3">
	    			<p class="f-14 mb-0" v-if="editalert && editalert.Symbol">{{$t('edit_price_alert') }} <span class="green font-weight-bold ml-2">{{currency_pair}}</span></p>
	    			<p class="f-14 mb-0" v-else>{{$t('create_price_alert') }}<span class="green font-weight-bold ml-2">{{currency_pair}}</span></p>
	    			<span class="closePOP" @click.prevent="$parent.editalert = {}" v-if="editalert && editalert.Symbol"><feather size="13px" type="x"></feather></span>
					<span class="closePOP" @click.prevent="$parent.alertTab = false" v-else><feather size="13px" type="x"></feather></span>
	    		</div>
                <div class="ppSuccess-icon text-center mt-4 mb-2">
                    <feather size="28px" type="check-circle" v-if="wsOrder[tempOrderId].stat == 'OK'"></feather>
                    <feather size="28px" type="alert-triangle" v-else></feather>
                </div>
		    	<h3 :class="(wsOrder[tempOrderId].stat == 'OK')?'green':'red'" v-html="wsOrder[tempOrderId].resp_msg"></h3>
                <a href="#" class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click.prevent="$parent.editalert = {}" v-if="editalert && editalert.Symbol">{{$t('close') }}</a>
                <a href="#" class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click.prevent="$parent.alertTab = false" v-else>{{$t('close') }}</a>
		    </div>
	    </div>
    </div>
</template>

<script>
import { Const } from '@/plugins/vue-provider-cache/const.mod'
import { commonAllmixins } from '@/plugins/commonAll'
import { Validator } from 'vee-validate';
const paramNames = ['val'];
const lessThen = (value, [val] = {}) => { return Number(val) > value; };
Validator.extend('lessThen', lessThen, { paramNames });

const greaterThen = (value, [val] ) => { return Number(val) < Number(value); };
Validator.extend('greaterThen', greaterThen, { paramNames });
export default {
    name: 'alert-pop',
    mixins: [commonAllmixins],
    data() {
        return {
            tradeType:'B', // B=>BID,A=>ASK
            condition:1, // 1=> above, 0=> below
            price:'',
            submitted:false,
            tempOrderId:'',
            comment:'',
        }
    },
    props:['currency_pair','editalert'],
    watch:{
        price(val){
            this.changeValidation('price',val)
        }
    },
    methods:{
        getStep(val){
            let data = this.instruments[this.currency_pair].B
            if(val == '' || parseFloat(val) == 0){
                return (parseFloat(data)).toString()
            }else if(val && data.toString().includes('.')){
                return 1/Math.pow(10, data.toString().split('.')[1].length)
            }else{
                return '1'
            }
        },
        changeValidation(variablName,val){
            let upper = 5, lower = 5;
            try{ upper = this.instruments[this.currency_pair].B.split('.')[0].length}catch(e){}
            try{ lower = this.instruments[this.currency_pair].other.Tick_Size.split('.')[1].length}catch(e){}
            this[variablName] = val.toString()
                .replace(/[^\d.]/g, '')                 // numbers and decimals only
                .replace(this.getUpper(upper), '$1')    // not more than 2 digits at the beginning
                .replace(/(\..*)\./g, '$1')             // decimal can't exist more than once
                .replace(this.getLower(lower), '$1');   // not more than 4 digits after decimal
        },
        getUpper(val){
            if(val == 1){ return /(^[\d]{1})[\d]/g}
            if(val == 2){ return /(^[\d]{2})[\d]/g}
            if(val == 3){ return /(^[\d]{3})[\d]/g}
            if(val == 4){ return /(^[\d]{4})[\d]/g}
            if(val == 5){ return /(^[\d]{5})[\d]/g}
            if(val == 6){ return /(^[\d]{6})[\d]/g}
            if(val == 7){ return /(^[\d]{7})[\d]/g}
            if(val == 8){ return /(^[\d]{8})[\d]/g}
            else{ return /(^[\d]{0})[\d]/g }
        },
        getLower(val){
            if(val == 1){ return /(\.[\d]{1})./g}
            if(val == 2){ return /(\.[\d]{2})./g}
            if(val == 3){ return /(\.[\d]{3})./g}
            if(val == 4){ return /(\.[\d]{4})./g}
            if(val == 5){ return /(\.[\d]{5})./g}
            if(val == 6){ return /(\.[\d]{6})./g}
            if(val == 7){ return /(\.[\d]{7})./g}
            if(val == 8){ return /(\.[\d]{8})./g}
            else{ return /(^[\d]{0})[\d]/g }
        },
    	addAlert(){
    		if(this.editalert && this.editalert.Symbol){
    			this.update()
    		}else{
	            var _that = this
	            this.submitted =  true
	            _that.$validator.validate().then(valid => {
	                if (valid && !_that.orderPlacedWait) {
	                    const tempOrderId = new Date().getTime()
	                    this.submitted =  false
	                    let orderJson = {
	                        "symbol" : _that.currency_pair,
	                        "type" : (_that.tradeType == 'B')?'BID':'ASK',
	                        "price" : _that.price,
	                        "Commentary" : _that.comment,
	                        "tempOrderId" : tempOrderId,
	                        'localParams' : _that
	                    }
	                    this.tempOrderId = orderJson.tempOrderId
	                    // console.log('order',orderJson)
	                    this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].createPriceAlert(orderJson)
	                }
	            });
    		}
        },
        update(){
    		var _that = this
            this.submitted =  true
            _that.$validator.validate().then(valid => {
                if (valid && !_that.orderPlacedWait) {
                    const tempOrderId = new Date().getTime()
                    this.submitted =  false
                    let orderJson = {
                        "alert_id" : _that.editalert.AlertID,
                        "type" : (_that.tradeType == 'B')?'BID':'ASK',
                        "price" : _that.price,
                        "tempOrderId" : tempOrderId,
                        "Commentary" : _that.comment,
                        "localParams" : _that
                    }
                    this.tempOrderId = orderJson.tempOrderId
                    // console.log('order',orderJson)
                    this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].modifyPriceAlert(orderJson)
                }
            });
    	},
        successWs(){
			// this.orderPlacedWait = true
        },
        failedWs(){
			this.displayError('faild to Place order','error')
			// this.orderPending = ''
			// this.tempOrderId = {}
            console.log('failed')
        },
        displayError(getMessage,type){
			this.$notify({
				group: 'foo',
				type: (type && type == null)?'error':type,
				text: getMessage,
				duration: 2000,
				closeOnClick: true
			});
		},
    },
    computed:{
    	instruments() {
    	    try {                    
	            this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
	            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
	        } catch (ex) {                
	            return []
	        }
	    }
    },
    created(){
    	if(this.editalert && this.editalert.Symbol){
    		if(this.editalert.Type == 'ASK'){
	    		this.tradeType = 'A';
	    	}else{ this.tradeType = 'B'; }
	    	if(this.instruments[this.currency_pair][this.tradeType] > this.editalert.Price){
	    		this.condition = 0
	    	}else{ this.condition = 1 }
	    	this.price = this.editalert.Price || ''
	    	this.comment = this.editalert.Commentary || ''
    	}	
    },
    mounted() {
			const _that = this
	        $(document).on("click", function(event){
				if(!$(event.target).closest('.openHeader').length){
	                _that.openHeader = false
	            }
	        });
		}
    
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/price-alert.vue